import React from "react";
import { Grid, Box, Typography, Link } from "@mui/material";
import { useParams, useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import AddCircleIcon from '@mui/icons-material/AddCircle';

import { useCourse } from "../../hooks";
import Button from "../../../../components/Button";
import { AssessmentCard } from "../../../../components/assessment";

export const Assessments = () => {
    const theme = useTheme();
    const navigate = useNavigate();

    const {courseId, planId, sectionId, chapterId} = useParams();
    const {loadLessonPlan, lessonPlan} = useCourse();

    const [assessments, setAssessments] = React.useState([]);

    React.useEffect(() => {
        loadLessonPlan({id: courseId});
    }, [courseId]);

    React.useEffect(() => {
        if (lessonPlan && Object.keys(lessonPlan).length) {
            let section = lessonPlan.sections.find(e => e.sectionId === sectionId);
            let chapter = section.chapters.find(e => e.chapterId === chapterId);

            if (chapter.assessments) {
                setAssessments(chapter.assessments);
            }
        }
    }, [lessonPlan]);

    return (
        <div>
            <div className='course'>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}>
                    <Typography
                        align="left"
                        variant="h1"
                        color="primary.blue"
                        sx={{
                            margin: '0',
                            fontWeight: '700',
                            lineHeight: '1.5',
                            fontSize: '1.8rem',
                        }}>Manage Assessments</Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            [theme.breakpoints.down('sm')]: {
                                flexDirection: 'row',
                            },
                        }}>
                        
                        <div style={styles.create}>
                            <Link
                                component="button"
                                variant="body2"
                                onClick={() => navigate(location.pathname + '/create')}
                                title='Create Course'
                                sx={{
                                    background: 'tranaparent',
                                    color: 'var(--mui-palette-primary-button)',
                                    p: 0,
                                }}
                            >
                                <AddCircleIcon sx={{ fontSize: '1.8rem', marginTop: '4px' }} />
                            </Link>
                        </div>
                    </Box>
                </Box>
            </div>

            <Grid container sx={{ mt: 2 }} spacing={4}>
                {assessments.map((e, i) => <AssessmentCard key={i} cardActions={
                    <Button onClick={() => navigate(`/quiz/${e.assessmentId}`)} />
                } assessment={e} />)}
            </Grid>
        </div>
    );
}

const styles = {
    header: {
        textAlign: 'center',
        margin: '0',
        fontWeight: '500',
        lineHeight: '1.5'
    },
}